// Утилита для управления настройками фронтенда

const DEFAULT_SETTINGS = {
  // Основной фон
  mainBackground: '#111827',
  mainBackgroundImage: '',
  mainBackgroundImageOpacity: 1,
  
  // Фон модалок
  modalBackground: '#1f2937',
  modalBackgroundImage: '',
  modalBackgroundImageOpacity: 1,
  applyGlobalModalBackground: true,
  modalTextColor: '#ffffff',
  modalDateTextColor: '#ffffff',
  modalHeaderTextColor: '#60a5fa',
  modalFieldLabelTextColor: '#d1d5db',
  frontendSettingsModalTextColor: '#ffffff',
  modalBorderColor: 'rgba(75, 85, 99, 0.3)',
  modalButtonBackground: '#3b82f6',
  modalButtonTextColor: '#ffffff',
  modalInputBackground: '#2d3748',
  modalInputTextColor: '#ffffff',
  modalFilterBackground: 'rgba(255, 193, 7, 0.08)',
  modalFilterTextColor: '#a0aec0',
  modalFilterBorderColor: 'rgba(255, 193, 7, 0.3)',
  modalReportBlockBackground: 'rgba(67, 233, 123, 0.05)',
  modalActionButtonBackground: '#3b82f6',
  modalActionButtonTextColor: '#ffffff',
  modalActionButtonBorderColor: 'rgba(59, 130, 246, 0.6)',
  modalPrimaryActionButtonBackground: '#22c55e',
  modalPrimaryActionButtonTextColor: '#ffffff',
  modalPrimaryActionButtonBorderColor: 'rgba(34, 197, 94, 0.7)',
  modalDangerActionButtonBackground: '#ef4444',
  modalDangerActionButtonTextColor: '#ffffff',
  modalDangerActionButtonBorderColor: 'rgba(239, 68, 68, 0.7)',
  enableGlobalActionButtons: true,
  clockBackground: 'rgba(17, 24, 39, 0.7)',
  clockBorderColor: 'rgba(255, 255, 255, 0.16)',
  clockTimeColor: '#eaf2f9',
  clockWeekdayColor: '#cbd5f5',
  clockMonthColor: '#eaf2f9',
  clockOffsetX: 0,
  clockOffsetY: 0,
  
  // Сайдбар
  sidebarButtonBackground: '#3b82f6',
  sidebarButtonBackgroundImage: '',
  sidebarButtonBackgroundImageOpacity: 0.1,
  sidebarTextColor: '#ffffff',
  sidebarTextSize: '14px',
  sidebarTextAlign: 'left',
  sidebarFontFamily: 'Inter, system-ui, -apple-system, sans-serif',
  sidebarHeaderBackground: 'linear-gradient(135deg, #232526 0%, #232931 100%)',
  sidebarHeaderBackgroundImage: '',
  sidebarHeaderBackgroundImageOpacity: 1,
  sidebarHeaderNameColor: '#6dd5ed',
  sidebarHeaderDepartmentColor: '#b2bec3',
  sidebarHeaderAvatarOffsetX: 0,
  sidebarHeaderAvatarOffsetY: 0,
  sidebarUseHeaderBackgroundForButtons: false,

  // Стили ячеек таблиц (обычное состояние и при наведении)
  tableCellBackground: 'rgba(44, 62, 80, 0.3)',
  tableCellTextColor: '#ffffff',
  tableCellHoverBackground: 'rgba(44, 62, 80, 0.5)',
  tableCellHoverTextColor: '#ffffff',
  // Цвет текста поля «Дедлайн» (где отображается дата с иконкой часов)
  deadlineFieldTextColor: '#e2e8f0',
};

// Дефолтные настройки для модалки "Заказы" и "Сбор товаров"
if (!DEFAULT_SETTINGS.modals) DEFAULT_SETTINGS.modals = {};
DEFAULT_SETTINGS.modals['warehouse-orders'] = {
  background: 'linear-gradient(160deg, #f8fafc 0%, #f1f5f9 45%, #e8eef4 100%)',
  textColor: '#1e293b',
  headerTextColor: '#0f766e',
  buttonBackground: 'rgba(255, 255, 255, 0.92)',
  buttonTextColor: '#334155',
};
DEFAULT_SETTINGS.modals['warehouse-picking'] = {
  textColor: '#1e293b',
  headerTextColor: '#0f766e',
  productBlockTextColor: '#1e293b',
  productBlockBackground: 'rgba(255, 255, 255, 0.75)',
  productRowBackground: 'rgba(255, 255, 255, 0.95)',
  noStockButtonTextColor: '#b91c1c',
  counterTextColor: '#0f766e',
  counterButtonTextColor: '#ffffff',
  counterButtonBackground: '#0d7377',
  counterInputBackground: '#ffffff',
};

// Дефолт фона модалки ВПР (один источник правды; на клиентах без сохранённых настроек фон не должен быть прозрачным)
export const VPR_DEFAULT_BACKGROUND = 'linear-gradient(135deg, #e8eef2 0%, #b0d4dc 100%)';
const VPR_DEFAULT_TEXT_COLOR = '#1a5f6e';
DEFAULT_SETTINGS.modals.vpr = {
  ...DEFAULT_SETTINGS.modals.vpr,
  background: VPR_DEFAULT_BACKGROUND,
  fileLabelColor: VPR_DEFAULT_TEXT_COLOR,
  fileDescriptionColor: VPR_DEFAULT_TEXT_COLOR,
  dateLabelColor: VPR_DEFAULT_TEXT_COLOR,
};

// Загрузка настроек из localStorage (на удалённых клиентах сервер может отдавать настройки без modals.vpr — нормализуем)

function normalizeVprBackground(bg) {
  if (!bg || bg === 'transparent' || (typeof bg === 'string' && bg.trim() === '')) return VPR_DEFAULT_BACKGROUND;
  return bg;
}
export { normalizeVprBackground };

// Нормализация настроек перед сохранением/применением (чтобы у удалённых клиентов фон ВПР не был пустым/прозрачным и цвета текста не сбрасывались)
function normalizeSettingsVpr(settings) {
  if (!settings || typeof settings !== 'object') return settings;
  if (!settings.modals) settings.modals = {};
  if (!settings.modals.vpr || typeof settings.modals.vpr !== 'object') settings.modals.vpr = {};
  const v = settings.modals.vpr;
  v.background = normalizeVprBackground(v.background);
  if (v.fileLabelColor == null || v.fileLabelColor === '') v.fileLabelColor = (v.textColor || VPR_DEFAULT_TEXT_COLOR);
  if (v.fileDescriptionColor == null || v.fileDescriptionColor === '') v.fileDescriptionColor = (v.fileLabelColor || v.textColor || VPR_DEFAULT_TEXT_COLOR);
  if (v.dateLabelColor == null || v.dateLabelColor === '') v.dateLabelColor = (v.textColor || VPR_DEFAULT_TEXT_COLOR);
  return settings;
}

export const loadFrontendSettings = () => {
  try {
    const saved = localStorage.getItem('frontendSettings');
    if (saved) {
      const parsed = JSON.parse(saved);
      if (parsed && typeof parsed === 'object') {
        if (!parsed.modals) parsed.modals = {};
        if (!parsed.modals.vpr || typeof parsed.modals.vpr !== 'object') parsed.modals.vpr = {};
        const v = parsed.modals.vpr;
        v.background = normalizeVprBackground(v.background);
        if (v.fileLabelColor == null || v.fileLabelColor === '') v.fileLabelColor = (v.textColor || VPR_DEFAULT_TEXT_COLOR);
        if (v.fileDescriptionColor == null || v.fileDescriptionColor === '') v.fileDescriptionColor = (v.fileLabelColor || v.textColor || VPR_DEFAULT_TEXT_COLOR);
        if (v.dateLabelColor == null || v.dateLabelColor === '') v.dateLabelColor = (v.textColor || VPR_DEFAULT_TEXT_COLOR);
        // Дополняем корневые ключи дефолтами (стили таблиц, дедлайн), чтобы старые сохранённые настройки работали
        const merged = { ...DEFAULT_SETTINGS, ...parsed };
        merged.modals = { ...(DEFAULT_SETTINGS.modals || {}), ...(parsed.modals || {}) };
        return merged;
      }
    }
  } catch (error) {
    console.error('Ошибка загрузки настроек фронтенда:', error);
  }
  return DEFAULT_SETTINGS;
};

// Применение настроек к DOM
export const applyFrontendSettings = (settings = null) => {
  const activeSettings = settings || loadFrontendSettings();
  const applyGlobalModalBackground = activeSettings.applyGlobalModalBackground !== false;
  const globalModalBackground = activeSettings.modalBackground || '#1f2937';
  const globalModalBackgroundImage = activeSettings.modalBackgroundImage || '';
  const globalModalBackgroundImageOpacity = activeSettings.modalBackgroundImageOpacity || 1;

  // Сразу задаём фон модалки ВПР (чтобы после обновления страницы он не пропадал, даже если modals ещё не загружен)
  const vprBg = normalizeVprBackground(activeSettings.modals?.vpr?.background);
  document.documentElement.style.setProperty('--modal-vpr-background', vprBg);
  document.documentElement.style.setProperty('--modal-vpr-discrepancies-background', vprBg);
  const vprModals = activeSettings.modals?.vpr;
  const vprFileLabelColorEarly = (vprModals?.fileLabelColor != null && vprModals.fileLabelColor !== '') ? vprModals.fileLabelColor : (vprModals?.textColor || '#1a5f6e');
  const vprFileDescColorEarly = (vprModals?.fileDescriptionColor != null && vprModals.fileDescriptionColor !== '') ? vprModals.fileDescriptionColor : (vprModals?.fileLabelColor || vprModals?.textColor || '#1a5f6e');
  const vprDateLabelColorEarly = (vprModals?.dateLabelColor != null && vprModals.dateLabelColor !== '') ? vprModals.dateLabelColor : (vprModals?.textColor || '#1a5f6e');
  document.documentElement.style.setProperty('--modal-vpr-file-label-color', vprFileLabelColorEarly);
  document.documentElement.style.setProperty('--modal-vpr-file-description-color', vprFileDescColorEarly);
  document.documentElement.style.setProperty('--modal-vpr-date-label-color', vprDateLabelColorEarly);
  
  // Применяем основной фон
  document.documentElement.style.setProperty('--main-background', activeSettings.mainBackground);
  
  // Применяем изображение фона
  if (activeSettings.mainBackgroundImage) {
    document.documentElement.style.setProperty('--main-background-image', `url(${activeSettings.mainBackgroundImage})`);
    document.documentElement.style.setProperty('--main-background-image-opacity', activeSettings.mainBackgroundImageOpacity);
  } else {
    document.documentElement.style.setProperty('--main-background-image', 'none');
  }
  
  // Применяем фон модалок (общий дефолт)
  document.documentElement.style.setProperty('--modal-background', activeSettings.modalBackground);
  if (activeSettings.modalBackgroundImage) {
    document.documentElement.style.setProperty('--modal-background-image', `url(${activeSettings.modalBackgroundImage})`);
    document.documentElement.style.setProperty('--modal-background-image-opacity', activeSettings.modalBackgroundImageOpacity);
  } else {
    document.documentElement.style.setProperty('--modal-background-image', 'none');
  }
  document.documentElement.style.setProperty('--modal-default-background-image', activeSettings.modalBackgroundImage ? `url(${activeSettings.modalBackgroundImage})` : 'none');
  document.documentElement.style.setProperty('--modal-default-background-image-opacity', activeSettings.modalBackgroundImageOpacity || 1);
  
  // Применяем общие CSS переменные для всех модалок (если не заданы индивидуальные)
  document.documentElement.style.setProperty('--modal-default-background', activeSettings.modalBackground);
  document.documentElement.style.setProperty('--modal-default-text-color', activeSettings.modalTextColor || '#ffffff');
  document.documentElement.style.setProperty('--modal-default-date-text-color', activeSettings.modalDateTextColor || '#ffffff');
  document.documentElement.style.setProperty('--modal-default-header-text-color', activeSettings.modalHeaderTextColor || '#60a5fa');
  document.documentElement.style.setProperty('--modal-default-label-text-color', activeSettings.modalFieldLabelTextColor || '#d1d5db');
  document.documentElement.style.setProperty('--frontend-settings-modal-text-color', activeSettings.frontendSettingsModalTextColor || activeSettings.modalTextColor || '#ffffff');
  document.documentElement.style.setProperty('--modal-default-text-size', '14px');
  document.documentElement.style.setProperty('--modal-default-font-family', 'Inter, system-ui, -apple-system, sans-serif');
  document.documentElement.style.setProperty('--modal-default-button-background', activeSettings.modalButtonBackground || '#3b82f6');
  document.documentElement.style.setProperty('--modal-default-button-text-color', activeSettings.modalButtonTextColor || '#ffffff');
  document.documentElement.style.setProperty('--modal-default-input-background', activeSettings.modalInputBackground || '#2d3748');
  document.documentElement.style.setProperty('--modal-default-input-text-color', activeSettings.modalInputTextColor || '#ffffff');
  document.documentElement.style.setProperty('--modal-default-border-color', activeSettings.modalBorderColor || 'rgba(75, 85, 99, 0.3)');
  document.documentElement.style.setProperty('--modal-default-filter-background', activeSettings.modalFilterBackground || 'rgba(255, 193, 7, 0.08)');
  document.documentElement.style.setProperty('--modal-default-filter-text-color', activeSettings.modalFilterTextColor || '#a0aec0');
  document.documentElement.style.setProperty('--modal-default-filter-border-color', activeSettings.modalFilterBorderColor || 'rgba(255, 193, 7, 0.3)');
  document.documentElement.style.setProperty('--modal-default-report-block-background', activeSettings.modalReportBlockBackground || 'rgba(67, 233, 123, 0.05)');
  document.documentElement.style.setProperty('--modal-default-action-button-background', activeSettings.modalActionButtonBackground || '#3b82f6');
  document.documentElement.style.setProperty('--modal-default-action-button-text-color', activeSettings.modalActionButtonTextColor || '#ffffff');
  document.documentElement.style.setProperty('--modal-default-action-button-border-color', activeSettings.modalActionButtonBorderColor || 'rgba(59, 130, 246, 0.6)');
  document.documentElement.style.setProperty('--modal-default-action-primary-background', activeSettings.modalPrimaryActionButtonBackground || '#22c55e');
  document.documentElement.style.setProperty('--modal-default-action-primary-text-color', activeSettings.modalPrimaryActionButtonTextColor || '#ffffff');
  document.documentElement.style.setProperty('--modal-default-action-primary-border-color', activeSettings.modalPrimaryActionButtonBorderColor || 'rgba(34, 197, 94, 0.7)');
  document.documentElement.style.setProperty('--modal-default-action-danger-background', activeSettings.modalDangerActionButtonBackground || '#ef4444');
  document.documentElement.style.setProperty('--modal-default-action-danger-text-color', activeSettings.modalDangerActionButtonTextColor || '#ffffff');
  document.documentElement.style.setProperty('--modal-default-action-danger-border-color', activeSettings.modalDangerActionButtonBorderColor || 'rgba(239, 68, 68, 0.7)');
  document.documentElement.style.setProperty('--clock-background', activeSettings.clockBackground || 'rgba(17, 24, 39, 0.7)');
  document.documentElement.style.setProperty('--clock-border-color', activeSettings.clockBorderColor || 'rgba(255, 255, 255, 0.16)');
  document.documentElement.style.setProperty('--clock-time-color', activeSettings.clockTimeColor || '#eaf2f9');
  document.documentElement.style.setProperty('--clock-weekday-color', activeSettings.clockWeekdayColor || '#cbd5f5');
  document.documentElement.style.setProperty('--clock-month-color', activeSettings.clockMonthColor || '#eaf2f9');
  document.documentElement.style.setProperty('--clock-offset-x', `${activeSettings.clockOffsetX || 0}px`);
  document.documentElement.style.setProperty('--clock-offset-y', `${activeSettings.clockOffsetY || 0}px`);

  // Стили ячеек таблиц (обычное состояние и при наведении)
  document.documentElement.style.setProperty('--table-cell-background', activeSettings.tableCellBackground || 'rgba(44, 62, 80, 0.3)');
  document.documentElement.style.setProperty('--table-cell-text-color', activeSettings.tableCellTextColor || '#ffffff');
  document.documentElement.style.setProperty('--table-cell-hover-background', activeSettings.tableCellHoverBackground || 'rgba(44, 62, 80, 0.5)');
  document.documentElement.style.setProperty('--table-cell-hover-text-color', activeSettings.tableCellHoverTextColor || '#ffffff');
  // Цвет текста поля «Дедлайн» (дата с иконкой часов)
  document.documentElement.style.setProperty('--deadline-field-text-color', activeSettings.deadlineFieldTextColor || '#e2e8f0');

  // Индивидуальные стили: "Заказы" и "Сбор товаров"
  const orders = (activeSettings.modals && activeSettings.modals['warehouse-orders'])
    ? activeSettings.modals['warehouse-orders']
    : DEFAULT_SETTINGS.modals['warehouse-orders'];
  const picking = (activeSettings.modals && activeSettings.modals['warehouse-picking'])
    ? activeSettings.modals['warehouse-picking']
    : DEFAULT_SETTINGS.modals['warehouse-picking'];

  document.documentElement.style.setProperty('--warehouse-orders-background', orders.background || DEFAULT_SETTINGS.modals['warehouse-orders'].background);
  document.documentElement.style.setProperty('--warehouse-orders-text-color', orders.textColor || DEFAULT_SETTINGS.modals['warehouse-orders'].textColor);
  document.documentElement.style.setProperty('--warehouse-orders-header-text-color', orders.headerTextColor || DEFAULT_SETTINGS.modals['warehouse-orders'].headerTextColor);
  document.documentElement.style.setProperty('--warehouse-orders-button-bg', orders.buttonBackground || DEFAULT_SETTINGS.modals['warehouse-orders'].buttonBackground);
  document.documentElement.style.setProperty('--warehouse-orders-button-text', orders.buttonTextColor || DEFAULT_SETTINGS.modals['warehouse-orders'].buttonTextColor);

  document.documentElement.style.setProperty('--warehouse-picking-text-color', picking.textColor || DEFAULT_SETTINGS.modals['warehouse-picking'].textColor);
  document.documentElement.style.setProperty('--warehouse-picking-header-text-color', picking.headerTextColor || DEFAULT_SETTINGS.modals['warehouse-picking'].headerTextColor);
  document.documentElement.style.setProperty('--warehouse-picking-product-text', picking.productBlockTextColor || DEFAULT_SETTINGS.modals['warehouse-picking'].productBlockTextColor);
  document.documentElement.style.setProperty('--warehouse-picking-product-bg', picking.productBlockBackground || DEFAULT_SETTINGS.modals['warehouse-picking'].productBlockBackground);
  document.documentElement.style.setProperty('--warehouse-picking-row-bg', picking.productRowBackground || DEFAULT_SETTINGS.modals['warehouse-picking'].productRowBackground);
  document.documentElement.style.setProperty('--warehouse-picking-no-stock-text', picking.noStockButtonTextColor || DEFAULT_SETTINGS.modals['warehouse-picking'].noStockButtonTextColor);
  document.documentElement.style.setProperty('--warehouse-picking-counter-text', picking.counterTextColor || DEFAULT_SETTINGS.modals['warehouse-picking'].counterTextColor);
  document.documentElement.style.setProperty('--warehouse-picking-counter-btn-text', picking.counterButtonTextColor || DEFAULT_SETTINGS.modals['warehouse-picking'].counterButtonTextColor);
  document.documentElement.style.setProperty('--warehouse-picking-counter-btn-bg', picking.counterButtonBackground || DEFAULT_SETTINGS.modals['warehouse-picking'].counterButtonBackground);
  document.documentElement.style.setProperty('--warehouse-picking-counter-input-bg', picking.counterInputBackground || DEFAULT_SETTINGS.modals['warehouse-picking'].counterInputBackground);

  const warehouseStyleId = 'warehouse-orders-picking-styles';
  const existingWarehouseStyle = document.getElementById(warehouseStyleId);
  const warehouseStyle = existingWarehouseStyle || document.createElement('style');
  warehouseStyle.id = warehouseStyleId;
  warehouseStyle.textContent = `
    /* Warehouse Orders modal — фон и текст; кнопки вкладок/поиска из настроек (футер и действия в карточке — градиенты из CSS) */
    .warehouse-orders-modal {
      background: var(--warehouse-orders-background) !important;
      color: var(--warehouse-orders-text-color) !important;
    }
    .warehouse-orders-modal h1,
    .warehouse-orders-modal h2,
    .warehouse-orders-modal h3,
    .warehouse-orders-modal .warehouse-orders-header h2 {
      color: var(--warehouse-orders-header-text-color) !important;
    }
    .warehouse-orders-modal .warehouse-orders-tabs button,
    .warehouse-orders-modal .warehouse-orders-search button {
      background: var(--warehouse-orders-button-bg) !important;
      color: var(--warehouse-orders-button-text) !important;
      border-color: rgba(15, 23, 42, 0.1) !important;
    }
    .warehouse-orders-modal .warehouse-orders-tabs button.active {
      background: rgba(13, 115, 119, 0.16) !important;
      color: #0a5c5f !important;
    }

    /* Сбор товаров: контейнер .wh-picking-shell (без подстроки "modal" в имени класса — иначе цепляются глобальные стили таблиц) */
    .wh-picking-shell {
      color: var(--warehouse-orders-text-color, var(--warehouse-picking-text-color, #1a1d21)) !important;
      background: var(--warehouse-orders-background, linear-gradient(160deg, #f8fafc 0%, #f1f5f9 50%, #e8eef4 100%)) !important;
    }
    .wh-picking-shell .picking-content {
      background: transparent !important;
    }
    .wh-picking-shell h1,
    .wh-picking-shell h2,
    .wh-picking-shell h3 {
      color: var(--warehouse-orders-header-text-color, var(--warehouse-picking-header-text-color, #0d7377)) !important;
    }
    .wh-picking-shell .picking-items {
      background: rgba(255, 255, 255, 0.94) !important;
      border: 1px solid rgba(0, 0, 0, 0.08) !important;
    }
    .wh-picking-shell .picking-table {
      background: transparent !important;
      --picking-card-border: #0d0d0d !important;
    }
    .wh-picking-shell .picking-table tbody {
      background: transparent !important;
    }
    .wh-picking-shell .picking-table thead .picking-thead-merged {
      background: transparent !important;
      border: none !important;
    }
    .wh-picking-shell .picking-thead-labels {
      background: rgba(13, 115, 119, 0.10) !important;
      color: #0a5c5f !important;
      border: 1px solid #0d0d0d !important;
    }
    .wh-picking-shell .picking-row-td-merged {
      background: transparent !important;
      border: none !important;
    }
    .wh-picking-shell .picking-row-card {
      border: 1px solid #0d0d0d !important;
    }
    .wh-picking-shell .picking-table-row:not(.done) .picking-row-card {
      background: rgba(255, 255, 255, 0.98) !important;
    }
    .wh-picking-shell .picking-table-row.done .picking-row-card {
      background: rgba(34, 197, 94, 0.14) !important;
    }
    .wh-picking-shell .picking-title-text,
    .wh-picking-shell .picking-qty-required {
      color: #1a1d21 !important;
    }
    .wh-picking-shell .btn-remove-from-order-text {
      color: var(--warehouse-picking-no-stock-text) !important;
    }
    .wh-picking-shell .qty-pick-input {
      background: var(--warehouse-picking-counter-input-bg) !important;
      color: var(--warehouse-picking-counter-text) !important;
      border-color: rgba(13, 115, 119, 0.25) !important;
    }
    .wh-picking-shell .picking-qty-controls .qty-pick-btn {
      background: var(--warehouse-picking-counter-btn-bg, #0d7377) !important;
      color: var(--warehouse-picking-counter-btn-text, #ffffff) !important;
      -webkit-text-fill-color: var(--warehouse-picking-counter-btn-text, #ffffff) !important;
      border: 1px solid rgba(0, 0, 0, 0.28) !important;
      font-weight: 800 !important;
    }
  `;
  document.head.appendChild(warehouseStyle);

  // Цвет заголовков модалок: подставляем текущее значение в стиль, чтобы правило с !important перебивало любые инлайн-стили
  const headerColorValue = activeSettings.modalHeaderTextColor || '#60a5fa';
  const modalHeaderStyleId = 'global-modal-header-text-styles';
  const existingModalHeaderStyle = document.getElementById(modalHeaderStyleId);
  const modalHeaderStyle = existingModalHeaderStyle || document.createElement('style');
  modalHeaderStyle.id = modalHeaderStyleId;
  modalHeaderStyle.textContent = `
    .ReactModal__Content h1,
    .ReactModal__Content h2,
    .ReactModal__Content h3,
    .ReactModal__Content h4,
    .ReactModal__Content h5,
    .ReactModal__Content h6,
    .ReactModal__Content .modal-header,
    .ReactModal__Content .modal-title,
    .ReactModal__Content .title,
    .ReactModal__Content .header,
    .ReactModal__Content .section-title,
    .ReactModal__Content [class*="title"],
    .ReactModal__Content [class*="header"] {
      color: ${headerColorValue} !important;
    }
    /* Онбординг: светлый контент; глобальная покраска заголовков модалок не должна сюда заходить */
    .onboarding-modal-light-ui h1,
    .onboarding-modal-light-ui h2,
    .onboarding-modal-light-ui h3,
    .onboarding-modal-light-ui h4,
    .onboarding-modal-light-ui h5,
    .onboarding-modal-light-ui h6 {
      color: #0f172a !important;
      -webkit-text-fill-color: #0f172a !important;
    }
    /* Строка категории: className styled часто содержит "header" — отдельный якорь */
    .onboarding-category-row,
    .onboarding-category-row h1,
    .onboarding-category-row h2,
    .onboarding-category-row h3,
    .onboarding-category-row h4,
    .onboarding-category-row h5,
    .onboarding-category-row h6 {
      color: #0f172a !important;
      -webkit-text-fill-color: #0f172a !important;
    }
    .onboarding-category-row svg {
      color: #667eea !important;
      -webkit-text-fill-color: #667eea !important;
    }
    /* Новый дизайн держит свои токены темы — глобальная покраска заголовков сюда не заходит */
    .nd-report h1,
    .nd-report h2,
    .nd-report h3,
    .nd-mobileNavPanel h1,
    .nd-mobileNavPanel h3,
    .nd-calSheet h2,
    .nd-calSheet h3,
    .nd-empModal h3,
    .nd-sheetHead h2,
    .nd-tdViewBox h3,
    .nd-mBox h3 {
      color: var(--nd-txt) !important;
      -webkit-text-fill-color: var(--nd-txt) !important;
    }
    .nd-sheetHead h2 span {
      color: var(--nd-mut) !important;
      -webkit-text-fill-color: var(--nd-mut) !important;
    }
    .nd-empHead h2 {
      color: #fff !important;
      -webkit-text-fill-color: #fff !important;
    }
    .nd-chatsSide h3 {
      color: var(--nd-txt) !important;
      -webkit-text-fill-color: var(--nd-txt) !important;
    }
    .nd-report h1 span,
    .nd-calSheet h2 span {
      color: var(--nd-mut) !important;
      -webkit-text-fill-color: var(--nd-mut) !important;
    }
    .nd-calSheet .nd-appr h4 {
      color: var(--nd-amber) !important;
      -webkit-text-fill-color: var(--nd-amber) !important;
    }
  `;
  if (!existingModalHeaderStyle) {
    document.head.appendChild(modalHeaderStyle);
  }

  // Стили ячеек таблиц в модалках (обычное состояние и при наведении) — используем уже заданные CSS-переменные
  const tableCellStyleId = 'global-table-cell-styles';
  let tableCellStyle = document.getElementById(tableCellStyleId);
  if (!tableCellStyle) {
    tableCellStyle = document.createElement('style');
    tableCellStyle.id = tableCellStyleId;
    document.head.appendChild(tableCellStyle);
  }
  tableCellStyle.textContent = `
    .ReactModal__Content table td,
    .ReactModal__Content table th,
    .warehouse-stats-table td,
    .warehouse-stats-table th,
    .local-pc-activity-table td,
    .local-pc-activity-table th,
    table.warehouse-stats-table td,
    table.warehouse-stats-table th,
    table.local-pc-activity-table td,
    table.local-pc-activity-table th,
    [class*="modal"] table td,
    [class*="modal"] table th,
    [class*="Modal"] table td,
    [class*="Modal"] table th {
      background: var(--table-cell-background) !important;
      color: var(--table-cell-text-color) !important;
    }
    .warehouse-stats-table th.warehouse-stats-thead-wrap,
    .warehouse-stats-table td.warehouse-stats-card-cell {
      background: transparent !important;
    }
    .ReactModal__Content table tbody tr:hover td,
    .ReactModal__Content table tbody tr:hover th,
    .warehouse-stats-table tbody tr:hover td:not(.warehouse-stats-card-cell),
    .warehouse-stats-table tbody tr:hover th:not(.warehouse-stats-thead-wrap),
    .local-pc-activity-table tbody tr:hover td,
    .local-pc-activity-table tbody tr:hover th,
    [class*="modal"] table tbody tr:hover td,
    [class*="modal"] table tbody tr:hover th,
    [class*="Modal"] table tbody tr:hover td,
    [class*="Modal"] table tbody tr:hover th {
      background: var(--table-cell-hover-background) !important;
      color: var(--table-cell-hover-text-color) !important;
    }
    .nd-tableWrap tbody tr:hover td .nd-whoName,
    .nd-report tbody tr:hover td .nd-whoName {
      color: var(--table-cell-hover-text-color) !important;
      -webkit-text-fill-color: var(--table-cell-hover-text-color) !important;
    }
  `;

  // При вызове из applyFrontendSettings передаём текущий цвет; из observer — читаем из localStorage
  const applyModalHeaderStyles = (overrideHeaderColor) => {
    const headerColor = overrideHeaderColor !== undefined ? overrideHeaderColor : (loadFrontendSettings().modalHeaderTextColor || '#60a5fa');
    const nodes = document.querySelectorAll(
      'h1, h2, h3, h4, h5, h6, .modal-title, .modal-header, .title, .header, .section-title, [class*="title"], [class*="header"]'
    );
    const isModalContext = (el) => {
      let current = el;
      while (current && current !== document.body) {
        const role = current.getAttribute?.('role');
        if (role === 'dialog') return true;
        const className = (current.className || '').toString().toLowerCase();
        if (className.includes('modal')) return true;
        const computed = window.getComputedStyle(current);
        const zIndex = parseInt(computed.zIndex || '0', 10);
        if ((computed.position === 'fixed' || computed.position === 'absolute') && zIndex >= 1000) {
          return true;
        }
        current = current.parentElement;
      }
      return false;
    };
    const skipGlobalModalHeaderPaint = (el) => {
      if (!el) return false;
      if (el.closest?.('.wh-picking-shell')) return true;
      if (el.closest?.('.onboarding-modal-light-ui')) return true;
      if (el.closest?.('.kanban-modal-ui')) return true;
      if (el.closest?.('.nd-report')) return true;
      if (el.closest?.('.nd-mobileNavPanel')) return true;
      if (el.closest?.('.nd-calSheet')) return true;
      if (el.closest?.('.nd-empModal')) return true;
      if (el.closest?.('.nd-lvWrap')) return true;
      if (el.closest?.('.nd-chatsSide')) return true;
      if (el.closest?.('.nd-tdWrap')) return true;
      if (el.closest?.('.nd-todoWrap')) return true;
      if (el.closest?.('.nd-tdView')) return true;
      if (el.closest?.('.nd-monWrap')) return true;
      if (el.closest?.('.nd-remWrap')) return true;
      if (el.closest?.('.nd-runWrap')) return true;
      if (el.closest?.('.nd-mBox')) return true;
      if (el.classList?.contains?.('onboarding-category-row')) return true;
      if (el.closest?.('.onboarding-category-row')) return true;
      return false;
    };
    nodes.forEach((node) => {
      if (skipGlobalModalHeaderPaint(node)) {
        node.style.removeProperty('color');
        node.style.removeProperty('-webkit-text-fill-color');
        return;
      }
      if (isModalContext(node)) {
        node.style.setProperty('color', headerColor, 'important');
      }
    });
  };

  applyModalHeaderStyles(headerColorValue);
  if (!window.__modalHeaderObserver) {
    const observer = new MutationObserver(() => applyModalHeaderStyles());
    observer.observe(document.body, { childList: true, subtree: true });
    window.__modalHeaderObserver = observer;
  }

  const settingsModalsStyleId = 'global-settings-modals-styles';
  const existingSettingsModalsStyle = document.getElementById(settingsModalsStyleId);
  const settingsModalsStyle = existingSettingsModalsStyle || document.createElement('style');
  settingsModalsStyle.id = settingsModalsStyleId;
  settingsModalsStyle.textContent = `
    .frontend-settings-modal,
    .app-title-settings-modal {
      background: var(--modal-default-background, #1f2937) !important;
      color: var(--frontend-settings-modal-text-color, var(--modal-default-text-color, #ffffff)) !important;
      border-color: var(--modal-default-border-color, rgba(75, 85, 99, 0.3)) !important;
    }
    .frontend-settings-modal h1,
    .frontend-settings-modal h2,
    .frontend-settings-modal h3,
    .frontend-settings-modal h4,
    .frontend-settings-modal h5,
    .frontend-settings-modal h6,
    .app-title-settings-modal h1,
    .app-title-settings-modal h2,
    .app-title-settings-modal h3,
    .app-title-settings-modal h4,
    .app-title-settings-modal h5,
    .app-title-settings-modal h6 {
      color: var(--modal-default-header-text-color, #60a5fa) !important;
    }
    .frontend-settings-modal label,
    .app-title-settings-modal label,
    .frontend-settings-modal .frontend-settings-tabs-container button,
    .frontend-settings-modal .frontend-settings-tabs-container span,
    .frontend-settings-modal .frontend-settings-tabs-container svg {
      color: var(--frontend-settings-modal-text-color, var(--modal-default-label-text-color, #d1d5db)) !important;
    }
    .frontend-settings-modal .frontend-settings-tabs-container button svg {
      fill: currentColor !important;
      stroke: currentColor !important;
    }
    .frontend-settings-modal input,
    .frontend-settings-modal select,
    .frontend-settings-modal textarea,
    .app-title-settings-modal input,
    .app-title-settings-modal select,
    .app-title-settings-modal textarea {
      background: var(--modal-default-input-background, #2d3748) !important;
      color: var(--modal-default-input-text-color, #ffffff) !important;
      border-color: var(--modal-default-border-color, rgba(75, 85, 99, 0.3)) !important;
    }
    .frontend-settings-modal button,
    .app-title-settings-modal button {
      background: var(--modal-default-button-background, #3b82f6) !important;
      color: var(--modal-default-button-text-color, #ffffff) !important;
      border-color: var(--modal-default-border-color, rgba(75, 85, 99, 0.3)) !important;
    }
  `;
  if (!existingSettingsModalsStyle) {
    document.head.appendChild(settingsModalsStyle);
  }

  const applyModalLabelStyles = () => {
    const labelColor = activeSettings.modalFieldLabelTextColor || '#d1d5db';
    const frontendLabelColor = activeSettings.frontendSettingsModalTextColor || labelColor;
    const nodes = document.querySelectorAll(
      'label, .form-label, .field-label, .input-label, .label, .control-label, [class*="label"], [class*="field"]'
    );
    const isModalContext = (el) => {
      let current = el;
      while (current && current !== document.body) {
        const role = current.getAttribute?.('role');
        if (role === 'dialog') return true;
        const className = (current.className || '').toString().toLowerCase();
        if (className.includes('modal')) return true;
        const computed = window.getComputedStyle(current);
        const zIndex = parseInt(computed.zIndex || '0', 10);
        if ((computed.position === 'fixed' || computed.position === 'absolute') && zIndex >= 1000) {
          return true;
        }
        current = current.parentElement;
      }
      return false;
    };
    const skipGlobalModalLabelPaint = (el) => {
      if (!el) return false;
      if (el.closest?.('.wh-picking-shell')) return true;
      if (el.closest?.('.onboarding-modal-light-ui')) return true;
      if (el.classList?.contains?.('onboarding-category-row')) return true;
      if (el.closest?.('.onboarding-category-row')) return true;
      // Модалка прав: чекбоксы отделов на тёмном фоне — не красить «цветом лейблов» из настроек
      if (el.closest?.('.admin-user-rights-overlay')) return true;
      if (el.classList?.contains?.('user-rights-dept-chip')) return true;
      return false;
    };
    nodes.forEach((node) => {
      if (skipGlobalModalLabelPaint(node)) {
        // Чипы отделов: явно светлый текст (removeProperty сбрасывает React inline — CSS !important ниже)
        if (node.classList?.contains?.('user-rights-dept-chip') || node.closest?.('.user-rights-dept-chip')) {
          node.style.setProperty('color', '#f8fafc', 'important');
          node.style.setProperty('-webkit-text-fill-color', '#f8fafc', 'important');
          return;
        }
        node.style.removeProperty('color');
        node.style.removeProperty('-webkit-text-fill-color');
        return;
      }
      if (isModalContext(node)) {
        const inFrontendSettings = !!node.closest?.('.frontend-settings-modal');
        const colorToApply = inFrontendSettings ? frontendLabelColor : labelColor;
        node.style.setProperty('color', colorToApply, 'important');
      }
    });
  };

  applyModalLabelStyles();
  if (!window.__modalLabelObserver) {
    const observer = new MutationObserver(() => applyModalLabelStyles());
    observer.observe(document.body, { childList: true, subtree: true });
    window.__modalLabelObserver = observer;
  }
  
  const modalButtonStyleId = 'global-modal-action-button-styles';
  const existingModalButtonStyle = document.getElementById(modalButtonStyleId);
  const modalButtonStyle = existingModalButtonStyle || document.createElement('style');
  modalButtonStyle.id = modalButtonStyleId;
  if (activeSettings.enableGlobalActionButtons === false) {
    if (existingModalButtonStyle) {
      existingModalButtonStyle.remove();
    }
  } else {
    modalButtonStyle.textContent = `
      .ReactModal__Content button,
      .ReactModal__Overlay button,
      body > div[role="dialog"] button,
      #app-modal-root button {
        background: var(--modal-default-action-button-background) !important;
        background-color: var(--modal-default-action-button-background) !important;
        color: var(--modal-default-action-button-text-color) !important;
        border-color: var(--modal-default-action-button-border-color) !important;
      }
    `;
    if (!existingModalButtonStyle) {
      document.head.appendChild(modalButtonStyle);
    }
  }
  
  const actionSettings = {
    general: {
      background: activeSettings.modalActionButtonBackground || '#3b82f6',
      text: activeSettings.modalActionButtonTextColor || '#ffffff',
      border: activeSettings.modalActionButtonBorderColor || 'rgba(59, 130, 246, 0.6)'
    },
    primary: {
      background: activeSettings.modalPrimaryActionButtonBackground || '#22c55e',
      text: activeSettings.modalPrimaryActionButtonTextColor || '#ffffff',
      border: activeSettings.modalPrimaryActionButtonBorderColor || 'rgba(34, 197, 94, 0.7)'
    },
    danger: {
      background: activeSettings.modalDangerActionButtonBackground || '#ef4444',
      text: activeSettings.modalDangerActionButtonTextColor || '#ffffff',
      border: activeSettings.modalDangerActionButtonBorderColor || 'rgba(239, 68, 68, 0.7)'
    }
  };
  
  window.__modalActionSettings = actionSettings;
  const dangerKeywords = ['удалить', 'очистить', 'сброс', 'delete', 'clear', 'remove', 'reset'];
  const primaryKeywords = ['открыть', 'добавить', 'open', 'add', 'создать', 'create'];
  
  const applyActionButtonStyles = () => {
    if (activeSettings.enableGlobalActionButtons === false) {
      return;
    }
    const buttons = document.querySelectorAll(
      '.ReactModal__Content button, .ReactModal__Overlay button, body > div[role="dialog"] button, #app-modal-root button'
    );
    buttons.forEach((button) => {
      if (button.closest?.('.wh-picking-shell')) return;
      const text = (button.textContent || '').trim().toLowerCase();
      let theme = window.__modalActionSettings?.general;
      if (dangerKeywords.some((keyword) => text.includes(keyword))) {
        theme = window.__modalActionSettings?.danger || theme;
      } else if (primaryKeywords.some((keyword) => text.includes(keyword))) {
        theme = window.__modalActionSettings?.primary || theme;
      }
      if (!theme) return;
      button.style.setProperty('background', theme.background, 'important');
      button.style.setProperty('background-color', theme.background, 'important');
      button.style.setProperty('color', theme.text, 'important');
      button.style.setProperty('border-color', theme.border, 'important');
      if (!button.style.border) {
        button.style.setProperty('border', `1px solid ${theme.border}`, 'important');
      }
    });
  };
  
  applyActionButtonStyles();
  if (!window.__modalActionObserver) {
    const observer = new MutationObserver(() => applyActionButtonStyles());
    observer.observe(document.body, { childList: true, subtree: true });
    window.__modalActionObserver = observer;
  }
  
  // Применяем индивидуальные настройки для каждой модалки
  if (activeSettings.modals) {
    const modalIds = ['calendar', 'chats', 'leaves', 'tasks', 'todo', 'news', 'employees', 'monitoring', 'remote-report', 'remote-report-details', 'local-pc-activity', 'local-pc-activity-details', 'app-usage-report', 'app-usage-details', 'worktime', 'management', 'vpr', 'vpr-discrepancies'];
    
    modalIds.forEach(modalId => {
      let modalSettings = activeSettings.modals?.[modalId];
      if (modalId === 'vpr') {
        modalSettings = { background: VPR_DEFAULT_BACKGROUND, ...modalSettings };
      }
      if (modalSettings) {
        // Фон модалки
        let effectiveBackground = applyGlobalModalBackground
          ? globalModalBackground
          : modalSettings.background;
        let effectiveBackgroundImage = applyGlobalModalBackground
          ? globalModalBackgroundImage
          : modalSettings.backgroundImage;
        let effectiveBackgroundImageOpacity = applyGlobalModalBackground
          ? globalModalBackgroundImageOpacity
          : (modalSettings.backgroundImageOpacity || 1);
        if (modalId === 'vpr' && modalSettings.background) {
          effectiveBackground = modalSettings.background;
          effectiveBackgroundImage = modalSettings.backgroundImage || '';
          effectiveBackgroundImageOpacity = modalSettings.backgroundImageOpacity ?? 1;
        }
        document.documentElement.style.setProperty(`--modal-${modalId}-background`, effectiveBackground);
        
        const isGradientBackground =
          typeof effectiveBackground === 'string' &&
          effectiveBackground.includes('gradient(');
        
        if (effectiveBackgroundImage) {
          document.documentElement.style.setProperty(`--modal-${modalId}-background-image`, `url(${effectiveBackgroundImage})`);
          document.documentElement.style.setProperty(`--modal-${modalId}-background-image-opacity`, effectiveBackgroundImageOpacity);
        } else if (isGradientBackground) {
          document.documentElement.style.setProperty(`--modal-${modalId}-background-image`, effectiveBackground);
          document.documentElement.style.setProperty(`--modal-${modalId}-background-image-opacity`, effectiveBackgroundImageOpacity || 1);
        } else {
          document.documentElement.style.setProperty(`--modal-${modalId}-background-image`, 'none');
          document.documentElement.style.setProperty(`--modal-${modalId}-background-image-opacity`, '1');
        }
        
        const globalTextColor = activeSettings.modalTextColor;
        const globalDateTextColor = activeSettings.modalDateTextColor;
        const globalBorderColor = activeSettings.modalBorderColor;
        const globalButtonBackground = activeSettings.modalButtonBackground;
        const globalButtonTextColor = activeSettings.modalButtonTextColor;
        const globalInputBackground = activeSettings.modalInputBackground;
        const globalInputTextColor = activeSettings.modalInputTextColor;
        const globalFilterBackground = activeSettings.modalFilterBackground;
        const globalFilterTextColor = activeSettings.modalFilterTextColor;
        const globalFilterBorderColor = activeSettings.modalFilterBorderColor;
        
        // Стили текста (глобально + индивидуально)
        const effectiveTextColor = modalSettings.textColor || globalTextColor;
        const effectiveDateTextColor = modalSettings.dateTextColor || globalDateTextColor;
        if (effectiveTextColor) {
          document.documentElement.style.setProperty(`--modal-${modalId}-text-color`, effectiveTextColor);
        }
        if (effectiveDateTextColor) {
          document.documentElement.style.setProperty(`--modal-${modalId}-date-text-color`, effectiveDateTextColor);
        }
        document.documentElement.style.setProperty(
          `--modal-${modalId}-header-text-color`,
          activeSettings.modalHeaderTextColor || '#60a5fa'
        );

        if (modalId === 'vpr') {
          document.documentElement.style.setProperty('--modal-vpr-background', normalizeVprBackground(modalSettings.background));
          if (modalSettings.headerColor) {
            document.documentElement.style.setProperty('--modal-vpr-header-text-color', modalSettings.headerColor);
          }
          if (modalSettings.textColor) {
            document.documentElement.style.setProperty('--modal-vpr-text-color', modalSettings.textColor);
          }
          // Цвет подписей «1. реестр УКРПОЧТА», «2. реестр НП», «3. загрузка 1С» — всегда задаём с приоритетом (как для кнопок)
          const vprFileLabelColor = (modalSettings.fileLabelColor != null && modalSettings.fileLabelColor !== '')
            ? modalSettings.fileLabelColor
            : (modalSettings.textColor || '#1a5f6e');
          document.documentElement.style.setProperty('--modal-vpr-file-label-color', vprFileLabelColor);
          // Цвет описаний под полями (Столбец B…, ТТН формата…, A — дата…)
          const vprFileDescColor = (modalSettings.fileDescriptionColor != null && modalSettings.fileDescriptionColor !== '')
            ? modalSettings.fileDescriptionColor
            : (modalSettings.fileLabelColor || modalSettings.textColor || '#1a5f6e');
          document.documentElement.style.setProperty('--modal-vpr-file-description-color', vprFileDescColor);
          if (modalSettings.buttonBackground) {
            document.documentElement.style.setProperty('--modal-vpr-button-background', modalSettings.buttonBackground);
          }
          if (modalSettings.buttonBorderColor) {
            document.documentElement.style.setProperty('--modal-vpr-button-border-color', modalSettings.buttonBorderColor);
          }
          if (modalSettings.buttonTextColor) {
            document.documentElement.style.setProperty('--modal-vpr-button-text-color', modalSettings.buttonTextColor);
          }
          if (modalSettings.dateLabelColor) {
            document.documentElement.style.setProperty('--modal-vpr-date-label-color', modalSettings.dateLabelColor);
          }
          if (modalSettings.dateFieldBackground) {
            document.documentElement.style.setProperty('--modal-vpr-date-field-background', modalSettings.dateFieldBackground);
          }
          if (modalSettings.dateFieldColor) {
            document.documentElement.style.setProperty('--modal-vpr-date-field-color', modalSettings.dateFieldColor);
          }
          if (modalSettings.dateFieldBorderColor) {
            document.documentElement.style.setProperty('--modal-vpr-date-field-border-color', modalSettings.dateFieldBorderColor);
          }
          if (modalSettings.findDiscrepanciesButtonBackground != null) {
            document.documentElement.style.setProperty('--modal-vpr-find-discrepancies-button-background', modalSettings.findDiscrepanciesButtonBackground);
          }
          if (modalSettings.findDiscrepanciesButtonTextColor) {
            document.documentElement.style.setProperty('--modal-vpr-find-discrepancies-button-text-color', modalSettings.findDiscrepanciesButtonTextColor);
          }
          if (modalSettings.findDiscrepanciesButtonBorderColor) {
            document.documentElement.style.setProperty('--modal-vpr-find-discrepancies-button-border-color', modalSettings.findDiscrepanciesButtonBorderColor);
          }
        }

        if (modalId === 'vpr-discrepancies') {
          const vprBg = activeSettings.modals?.vpr?.background;
          document.documentElement.style.setProperty('--modal-vpr-discrepancies-background', vprBg || 'inherit');
          if (modalSettings.tabBackground != null) {
            document.documentElement.style.setProperty('--modal-vpr-discrepancies-tab-background', modalSettings.tabBackground);
          }
          if (modalSettings.tabTextColor) {
            document.documentElement.style.setProperty('--modal-vpr-discrepancies-tab-text-color', modalSettings.tabTextColor);
          }
          if (modalSettings.tabBorderColor) {
            document.documentElement.style.setProperty('--modal-vpr-discrepancies-tab-border-color', modalSettings.tabBorderColor);
          }
          if (modalSettings.tabActiveBackground != null) {
            document.documentElement.style.setProperty('--modal-vpr-discrepancies-tab-active-background', modalSettings.tabActiveBackground);
          }
          if (modalSettings.tabActiveTextColor) {
            document.documentElement.style.setProperty('--modal-vpr-discrepancies-tab-active-text-color', modalSettings.tabActiveTextColor);
          }
          if (modalSettings.tabActiveBorderColor) {
            document.documentElement.style.setProperty('--modal-vpr-discrepancies-tab-active-border-color', modalSettings.tabActiveBorderColor);
          }
          if (modalSettings.tabHoverBackground != null) {
            document.documentElement.style.setProperty('--modal-vpr-discrepancies-tab-hover-background', modalSettings.tabHoverBackground);
          }
          if (modalSettings.tabHoverBorderColor) {
            document.documentElement.style.setProperty('--modal-vpr-discrepancies-tab-hover-border-color', modalSettings.tabHoverBorderColor);
          }
          if (modalSettings.tabHoverTextColor) {
            document.documentElement.style.setProperty('--modal-vpr-discrepancies-tab-hover-text-color', modalSettings.tabHoverTextColor);
          }
          if (modalSettings.headerColor) {
            document.documentElement.style.setProperty('--modal-vpr-discrepancies-header-color', modalSettings.headerColor);
          }
          if (modalSettings.textColor) {
            document.documentElement.style.setProperty('--modal-vpr-discrepancies-text-color', modalSettings.textColor);
          }
          if (modalSettings.buttonBackground != null) {
            document.documentElement.style.setProperty('--modal-vpr-discrepancies-button-background', modalSettings.buttonBackground);
          }
          if (modalSettings.buttonTextColor) {
            document.documentElement.style.setProperty('--modal-vpr-discrepancies-button-text-color', modalSettings.buttonTextColor);
          }
          if (modalSettings.buttonBorderColor) {
            document.documentElement.style.setProperty('--modal-vpr-discrepancies-button-border-color', modalSettings.buttonBorderColor);
          }
          if (modalSettings.resultsBackground != null) {
            document.documentElement.style.setProperty('--modal-vpr-discrepancies-results-background', modalSettings.resultsBackground);
          }
          if (modalSettings.resultsTextColor) {
            document.documentElement.style.setProperty('--modal-vpr-discrepancies-results-text-color', modalSettings.resultsTextColor);
          }
          if (modalSettings.resultsBorderColor) {
            document.documentElement.style.setProperty('--modal-vpr-discrepancies-results-border-color', modalSettings.resultsBorderColor);
          }
          if (modalSettings.summaryLabelColor) {
            document.documentElement.style.setProperty('--modal-vpr-discrepancies-summary-label-color', modalSettings.summaryLabelColor);
          }
          if (modalSettings.summaryValueColor) {
            document.documentElement.style.setProperty('--modal-vpr-discrepancies-summary-value-color', modalSettings.summaryValueColor);
          }
          if (modalSettings.summaryDateColor) {
            document.documentElement.style.setProperty('--modal-vpr-discrepancies-summary-date-color', modalSettings.summaryDateColor);
          }
          if (modalSettings.downloadButtonBackground != null) {
            document.documentElement.style.setProperty('--modal-vpr-discrepancies-download-button-background', modalSettings.downloadButtonBackground);
          }
          if (modalSettings.downloadButtonTextColor) {
            document.documentElement.style.setProperty('--modal-vpr-discrepancies-download-button-text-color', modalSettings.downloadButtonTextColor);
          }
          if (modalSettings.downloadButtonBorderColor) {
            document.documentElement.style.setProperty('--modal-vpr-discrepancies-download-button-border-color', modalSettings.downloadButtonBorderColor);
          }
          if (modalSettings.telegramButtonBackground != null) {
            document.documentElement.style.setProperty('--modal-vpr-discrepancies-telegram-button-background', modalSettings.telegramButtonBackground);
          }
          if (modalSettings.telegramButtonTextColor) {
            document.documentElement.style.setProperty('--modal-vpr-discrepancies-telegram-button-text-color', modalSettings.telegramButtonTextColor);
          }
          if (modalSettings.telegramButtonBorderColor) {
            document.documentElement.style.setProperty('--modal-vpr-discrepancies-telegram-button-border-color', modalSettings.telegramButtonBorderColor);
          }
          if (modalSettings.assignTaskButtonBackground != null) {
            document.documentElement.style.setProperty('--modal-vpr-discrepancies-assign-task-button-background', modalSettings.assignTaskButtonBackground);
          }
          if (modalSettings.assignTaskButtonTextColor) {
            document.documentElement.style.setProperty('--modal-vpr-discrepancies-assign-task-button-text-color', modalSettings.assignTaskButtonTextColor);
          }
          if (modalSettings.assignTaskButtonBorderColor) {
            document.documentElement.style.setProperty('--modal-vpr-discrepancies-assign-task-button-border-color', modalSettings.assignTaskButtonBorderColor);
          }
        }
        // Стили кнопок (для ВПР и «Результаты расхождений» приоритет у своих настроек, иначе глобальные)
        const preferModalButtonBg = (modalId === 'vpr' || modalId === 'vpr-discrepancies');
        const buttonBg = modalSettings.buttonBackgroundImage 
          ? `url(${modalSettings.buttonBackgroundImage})`
          : (preferModalButtonBg && modalSettings.buttonBackground != null && modalSettings.buttonBackground !== '')
            ? modalSettings.buttonBackground
            : (globalButtonBackground || modalSettings.buttonBackground);
        document.documentElement.style.setProperty(`--modal-${modalId}-button-background`, buttonBg);
        document.documentElement.style.setProperty(`--modal-${modalId}-button-background-opacity`, modalSettings.buttonBackgroundImageOpacity || 0.1);
        const buttonTextColor = preferModalButtonBg && (modalSettings.buttonTextColor != null && modalSettings.buttonTextColor !== '')
          ? modalSettings.buttonTextColor
          : (globalButtonTextColor || modalSettings.buttonTextColor || '#ffffff');
        document.documentElement.style.setProperty(`--modal-${modalId}-button-text-color`, buttonTextColor);
        document.documentElement.style.setProperty(`--modal-${modalId}-button-normal-background`, modalSettings.buttonNormalBackground || 'rgba(67, 233, 123, 0.1)');
        document.documentElement.style.setProperty(`--modal-${modalId}-icon-button-background`, modalSettings.iconButtonBackground || 'rgba(67, 233, 123, 0.15)');
        
        // Стили полей ввода
        document.documentElement.style.setProperty(`--modal-${modalId}-input-background`, globalInputBackground || modalSettings.inputBackground || '#2d3748');
        document.documentElement.style.setProperty(`--modal-${modalId}-border-color`, globalBorderColor || modalSettings.borderColor || 'rgba(67, 233, 123, 0.2)');
        document.documentElement.style.setProperty(`--modal-${modalId}-input-text-color`, globalInputTextColor || modalSettings.inputTextColor || '#ffffff');
        
        // Стили иконок заголовка (стрелка назад, крестик)
        document.documentElement.style.setProperty(`--modal-${modalId}-header-icon-color`, modalSettings.headerIconColor || '#43e97b');
        
        // Стили блока фильтров
        const filterBlockBg = modalSettings.filterBlockBackgroundImage 
          ? `url(${modalSettings.filterBlockBackgroundImage})`
          : modalSettings.filterBlockBackground || 'rgba(67, 233, 123, 0.08)';
        document.documentElement.style.setProperty(`--modal-${modalId}-filter-block-background`, filterBlockBg);
        
        // Стили блока навигации
        const navBlockBg = modalSettings.navBlockBackgroundImage 
          ? `url(${modalSettings.navBlockBackgroundImage})`
          : modalSettings.navBlockBackground || 'rgba(67, 233, 123, 0.1)';
        document.documentElement.style.setProperty(`--modal-${modalId}-nav-block-background`, navBlockBg);
        
        // Стили сетки календаря
        const calendarGridBg = modalSettings.calendarGridBackgroundImage 
          ? `url(${modalSettings.calendarGridBackgroundImage})`
          : modalSettings.calendarGridBackground || 'rgba(34, 40, 49, 0.97)';
        document.documentElement.style.setProperty(`--modal-${modalId}-calendar-grid-background`, calendarGridBg);
        document.documentElement.style.setProperty(`--modal-${modalId}-calendar-cell-background`, modalSettings.calendarCellBackground || 'rgba(67, 233, 123, 0.05)');
        document.documentElement.style.setProperty(`--modal-${modalId}-calendar-cell-text-color`, modalSettings.calendarCellTextColor || '#ffffff');
        document.documentElement.style.setProperty(`--modal-${modalId}-calendar-weekday-color`, modalSettings.calendarWeekdayColor || '#43e97b');
        
        // Стили для модалки Отгулы (leaves)
        document.documentElement.style.setProperty(`--modal-${modalId}-header-background`, modalSettings.headerBackground || 'rgba(35, 41, 49, 0.95)');
        // title-color: приоритет — индивидуальный (вкладка модалки) > глобальный «Цвет заголовков» (Основная) > дефолт
        document.documentElement.style.setProperty(
          `--modal-${modalId}-title-color`,
          modalSettings.titleColor || activeSettings.modalHeaderTextColor || '#43e97b'
        );
        document.documentElement.style.setProperty(`--modal-${modalId}-form-background`, modalSettings.formBackground || 'rgba(44, 62, 80, 0.22)');
        document.documentElement.style.setProperty(`--modal-${modalId}-card-background`, modalSettings.cardBackground || '#ffffff');
        document.documentElement.style.setProperty(`--modal-${modalId}-card-text-color`, modalSettings.cardTextColor || '#2193b0');
        document.documentElement.style.setProperty(`--modal-${modalId}-card-reason-color`, modalSettings.cardReasonColor || '#636e72');
        
        // Дополнительные стили кнопок навигации (если заданы)
        if (Object.prototype.hasOwnProperty.call(modalSettings, 'navButtonBackground')) {
          document.documentElement.style.setProperty(
            `--modal-${modalId}-nav-button-background`,
            modalSettings.navButtonBackground || 'rgba(163, 230, 53, 0.15)'
          );
          document.documentElement.style.setProperty(
            `--modal-${modalId}-nav-button-text-color`,
            modalSettings.navButtonTextColor || '#a3e635'
          );
          document.documentElement.style.setProperty(
            `--modal-${modalId}-nav-button-border-color`,
            modalSettings.navButtonBorderColor || 'rgba(163, 230, 53, 0.3)'
          );
          document.documentElement.style.setProperty(
            `--modal-${modalId}-nav-button-hover-background`,
            modalSettings.navButtonHoverBackground || 'rgba(163, 230, 53, 0.25)'
          );
          document.documentElement.style.setProperty(
            `--modal-${modalId}-nav-button-hover-text-color`,
            modalSettings.navButtonHoverTextColor || '#a3e635'
          );
          document.documentElement.style.setProperty(
            `--modal-${modalId}-nav-button-hover-border-color`,
            modalSettings.navButtonHoverBorderColor || '#a3e635'
          );
        }

        // Дополнительные стили кнопки "Показать отчет" (если заданы)
        if (Object.prototype.hasOwnProperty.call(modalSettings, 'showReportButtonWidth')) {
          document.documentElement.style.setProperty(
            `--modal-${modalId}-show-report-button-width`,
            `${modalSettings.showReportButtonWidth || 100}%`
          );
          document.documentElement.style.setProperty(
            `--modal-${modalId}-show-report-button-height`,
            `${modalSettings.showReportButtonHeight || 48}px`
          );
          document.documentElement.style.setProperty(
            `--modal-${modalId}-show-report-button-background`,
            modalSettings.showReportButtonBackground || '#43e97b'
          );
          document.documentElement.style.setProperty(
            `--modal-${modalId}-show-report-button-text-color`,
            modalSettings.showReportButtonTextColor || '#ffffff'
          );
        }
        
        if (modalId === 'remote-report') {
          document.documentElement.style.setProperty(
            '--modal-remote-report-report-card-background',
            modalSettings.reportCardBackground || 'linear-gradient(135deg, rgba(67, 233, 123, 0.05) 0%, rgba(33, 147, 176, 0.05) 100%)'
          );
          document.documentElement.style.setProperty(
            '--modal-remote-report-report-card-border-color',
            modalSettings.reportCardBorderColor || 'rgba(67, 233, 123, 0.2)'
          );
          document.documentElement.style.setProperty(
            '--modal-remote-report-report-text-color',
            modalSettings.reportTextColor || '#ffffff'
          );
          document.documentElement.style.setProperty(
            '--modal-remote-report-report-name-color',
            modalSettings.reportNameColor || '#43e97b'
          );
          document.documentElement.style.setProperty(
            '--modal-remote-report-report-date-color',
            modalSettings.reportDateColor || '#ffffff'
          );
          document.documentElement.style.setProperty(
            '--modal-remote-report-details-button-background',
            modalSettings.reportDetailsButtonBackground || 'linear-gradient(135deg, #2193b0 0%, #43e97b 100%)'
          );
          document.documentElement.style.setProperty(
            '--modal-remote-report-details-button-border-color',
            modalSettings.reportDetailsButtonBorderColor || 'rgba(33, 147, 176, 0.5)'
          );
          document.documentElement.style.setProperty(
            '--modal-remote-report-details-button-text-color',
            modalSettings.reportDetailsButtonTextColor || '#ffffff'
          );
        }
        
        if (modalId === 'remote-report-details') {
          document.documentElement.style.setProperty(
            '--modal-remote-report-details-card-background',
            modalSettings.detailCardBackground || 'linear-gradient(135deg, rgba(67, 233, 123, 0.1) 0%, rgba(67, 233, 123, 0.05) 100%)'
          );
          document.documentElement.style.setProperty(
            '--modal-remote-report-details-card-border-color',
            modalSettings.detailCardBorderColor || 'rgba(67, 233, 123, 0.3)'
          );
          document.documentElement.style.setProperty(
            '--modal-remote-report-details-text-color',
            modalSettings.detailTextColor || '#ffffff'
          );
          document.documentElement.style.setProperty(
            '--modal-remote-report-details-date-color',
            modalSettings.detailDateColor || '#ffffff'
          );
        }

        if (modalId === 'app-usage-report') {
          document.documentElement.style.setProperty(
            '--modal-app-usage-report-text-color',
            modalSettings.textColor || '#ffffff'
          );
          document.documentElement.style.setProperty(
            '--modal-app-usage-report-table-text-color',
            modalSettings.tableTextColor || '#ffffff'
          );
          document.documentElement.style.setProperty(
            '--modal-app-usage-report-table-header-text-color',
            modalSettings.tableHeaderTextColor || '#ffffff'
          );
          document.documentElement.style.setProperty(
            '--modal-app-usage-report-date-input-background',
            modalSettings.dateInputBackground || '#0f172a'
          );
          document.documentElement.style.setProperty(
            '--modal-app-usage-report-date-input-text-color',
            modalSettings.dateInputTextColor || '#ffffff'
          );
        }

        // Дополнительные стили кнопки "Закрыть" (если заданы)
        if (Object.prototype.hasOwnProperty.call(modalSettings, 'closeButtonWidth')) {
          document.documentElement.style.setProperty(
            `--modal-${modalId}-close-button-width`,
            `${modalSettings.closeButtonWidth || 100}%`
          );
          document.documentElement.style.setProperty(
            `--modal-${modalId}-close-button-height`,
            `${modalSettings.closeButtonHeight || 48}px`
          );
          document.documentElement.style.setProperty(
            `--modal-${modalId}-close-button-background`,
            modalSettings.closeButtonBackground || '#a3ffb0'
          );
          document.documentElement.style.setProperty(
            `--modal-${modalId}-close-button-text-color`,
            modalSettings.closeButtonTextColor || '#232931'
          );
        }

        if (Object.prototype.hasOwnProperty.call(modalSettings, 'filterAfterHoursBackground')) {
          document.documentElement.style.setProperty(
            `--modal-${modalId}-filter-after-hours-background`,
            globalFilterBackground || modalSettings.filterAfterHoursBackground || 'rgba(255, 193, 7, 0.1)'
          );
          document.documentElement.style.setProperty(
            `--modal-${modalId}-filter-after-hours-border-color`,
            globalFilterBorderColor || modalSettings.filterAfterHoursBorderColor || 'rgba(109, 213, 237, 0.3)'
          );
          document.documentElement.style.setProperty(
            `--modal-${modalId}-filter-after-hours-text-color`,
            globalFilterTextColor || modalSettings.filterAfterHoursTextColor || '#a0aec0'
          );
          document.documentElement.style.setProperty(
            `--modal-${modalId}-filter-weekdays-background`,
            globalFilterBackground || modalSettings.filterWeekdaysBackground || 'rgba(255, 193, 7, 0.05)'
          );
          document.documentElement.style.setProperty(
            `--modal-${modalId}-filter-weekdays-border-color`,
            globalFilterBorderColor || modalSettings.filterWeekdaysBorderColor || 'rgba(255, 193, 7, 0.3)'
          );
          document.documentElement.style.setProperty(
            `--modal-${modalId}-filter-weekdays-text-color`,
            globalFilterTextColor || modalSettings.filterWeekdaysTextColor || '#a0aec0'
          );
          document.documentElement.style.setProperty(
            `--modal-${modalId}-filter-weekends-background`,
            globalFilterBackground || modalSettings.filterWeekendsBackground || 'rgba(67, 233, 123, 0.05)'
          );
          document.documentElement.style.setProperty(
            `--modal-${modalId}-filter-weekends-border-color`,
            globalFilterBorderColor || modalSettings.filterWeekendsBorderColor || 'rgba(67, 233, 123, 0.3)'
          );
          document.documentElement.style.setProperty(
            `--modal-${modalId}-filter-weekends-text-color`,
            globalFilterTextColor || modalSettings.filterWeekendsTextColor || '#a0aec0'
          );
          document.documentElement.style.setProperty(
            `--modal-${modalId}-filter-pending-background`,
            globalFilterBackground || modalSettings.filterPendingBackground || 'transparent'
          );
          document.documentElement.style.setProperty(
            `--modal-${modalId}-filter-pending-border-color`,
            globalFilterBorderColor || modalSettings.filterPendingBorderColor || '#4a5568'
          );
          document.documentElement.style.setProperty(
            `--modal-${modalId}-filter-pending-text-color`,
            globalFilterTextColor || modalSettings.filterPendingTextColor || '#a0aec0'
          );
          document.documentElement.style.setProperty(
            `--modal-${modalId}-filter-completed-background`,
            globalFilterBackground || modalSettings.filterCompletedBackground || 'transparent'
          );
          document.documentElement.style.setProperty(
            `--modal-${modalId}-filter-completed-border-color`,
            globalFilterBorderColor || modalSettings.filterCompletedBorderColor || '#4a5568'
          );
          document.documentElement.style.setProperty(
            `--modal-${modalId}-filter-completed-text-color`,
            globalFilterTextColor || modalSettings.filterCompletedTextColor || '#a0aec0'
          );
        }

        if (Object.prototype.hasOwnProperty.call(modalSettings, 'showReportButtonBackground')) {
          document.documentElement.style.setProperty(
            `--modal-${modalId}-show-report-button-background`,
            modalSettings.showReportButtonBackground || '#27ae60'
          );
          document.documentElement.style.setProperty(
            `--modal-${modalId}-show-report-button-text-color`,
            modalSettings.showReportButtonTextColor || '#ffffff'
          );
          document.documentElement.style.setProperty(
            `--modal-${modalId}-delete-period-button-background`,
            modalSettings.deletePeriodButtonBackground || '#e74c3c'
          );
          document.documentElement.style.setProperty(
            `--modal-${modalId}-delete-period-button-text-color`,
            modalSettings.deletePeriodButtonTextColor || '#ffffff'
          );
          document.documentElement.style.setProperty(
            `--modal-${modalId}-delete-day-button-background`,
            modalSettings.deleteDayButtonBackground || '#e74c3c'
          );
          document.documentElement.style.setProperty(
            `--modal-${modalId}-delete-day-button-text-color`,
            modalSettings.deleteDayButtonTextColor || '#ffffff'
          );
          document.documentElement.style.setProperty(
            `--modal-${modalId}-delete-week-button-background`,
            modalSettings.deleteWeekButtonBackground || '#e74c3c'
          );
          document.documentElement.style.setProperty(
            `--modal-${modalId}-delete-week-button-text-color`,
            modalSettings.deleteWeekButtonTextColor || '#ffffff'
          );
          document.documentElement.style.setProperty(
            `--modal-${modalId}-delete-month-button-background`,
            modalSettings.deleteMonthButtonBackground || '#e74c3c'
          );
          document.documentElement.style.setProperty(
            `--modal-${modalId}-delete-month-button-text-color`,
            modalSettings.deleteMonthButtonTextColor || '#ffffff'
          );
        }


        if (Object.prototype.hasOwnProperty.call(modalSettings, 'tabBarBackground')) {
          document.documentElement.style.setProperty(
            `--modal-${modalId}-tab-bar-background`,
            modalSettings.tabBarBackground || '#1f2937'
          );
          document.documentElement.style.setProperty(
            `--modal-${modalId}-tab-background`,
            modalSettings.tabBackground || 'rgba(255, 255, 255, 0.1)'
          );
          document.documentElement.style.setProperty(
            `--modal-${modalId}-tab-text-color`,
            modalSettings.tabTextColor || '#ffffff'
          );
          document.documentElement.style.setProperty(
            `--modal-${modalId}-tab-border-color`,
            modalSettings.tabBorderColor || 'transparent'
          );
          document.documentElement.style.setProperty(
            `--modal-${modalId}-tab-active-background`,
            modalSettings.tabActiveBackground || '#ffffff'
          );
          document.documentElement.style.setProperty(
            `--modal-${modalId}-tab-active-text-color`,
            modalSettings.tabActiveTextColor || '#000000'
          );
          document.documentElement.style.setProperty(
            `--modal-${modalId}-tab-active-border-color`,
            modalSettings.tabActiveBorderColor || '#000000'
          );
          document.documentElement.style.setProperty(
            `--modal-${modalId}-block-background`,
            modalSettings.blockBackground || 'rgba(255, 255, 255, 0.08)'
          );
          document.documentElement.style.setProperty(
            `--modal-${modalId}-block-text-color`,
            modalSettings.blockTextColor || '#ffffff'
          );
          document.documentElement.style.setProperty(
            `--modal-${modalId}-block-border-color`,
            modalSettings.blockBorderColor || 'rgba(0, 0, 0, 0.6)'
          );
          document.documentElement.style.setProperty(
            `--modal-${modalId}-block-header-text-color`,
            modalSettings.blockHeaderTextColor || '#000000'
          );
        }

        if (Object.prototype.hasOwnProperty.call(modalSettings, 'statsCardBackground')) {
          document.documentElement.style.setProperty(
            `--modal-${modalId}-stats-card-background`,
            modalSettings.statsCardBackground || '#27ae60'
          );
          document.documentElement.style.setProperty(
            `--modal-${modalId}-stats-card-border-color`,
            modalSettings.statsCardBorderColor || '#000000'
          );
          document.documentElement.style.setProperty(
            `--modal-${modalId}-stats-card-title-color`,
            modalSettings.statsCardTitleColor || '#000000'
          );
          document.documentElement.style.setProperty(
            `--modal-${modalId}-stats-card-value-color`,
            modalSettings.statsCardValueColor || '#ffffff'
          );
          document.documentElement.style.setProperty(
            `--modal-${modalId}-stats-card-subtext-color`,
            modalSettings.statsCardSubtextColor || 'rgba(0, 0, 0, 0.6)'
          );
          document.documentElement.style.setProperty(
            `--modal-${modalId}-top-apps-background`,
            modalSettings.topAppsBackground || '#3d3a3a'
          );
          document.documentElement.style.setProperty(
            `--modal-${modalId}-top-apps-border-color`,
            modalSettings.topAppsBorderColor || '#000000'
          );
          document.documentElement.style.setProperty(
            `--modal-${modalId}-top-apps-text-color`,
            modalSettings.topAppsTextColor || 'rgba(251, 198, 84, 0.94)'
          );
          document.documentElement.style.setProperty(
            `--modal-${modalId}-event-card-background`,
            modalSettings.eventCardBackground || 'rgba(67, 233, 123, 0.1)'
          );
          document.documentElement.style.setProperty(
            `--modal-${modalId}-event-card-border-color`,
            modalSettings.eventCardBorderColor || 'rgba(67, 233, 123, 0.3)'
          );
          document.documentElement.style.setProperty(
            `--modal-${modalId}-event-title-color`,
            modalSettings.eventTitleColor || '#43e97b'
          );
          document.documentElement.style.setProperty(
            `--modal-${modalId}-event-text-color`,
            modalSettings.eventTextColor || '#111111'
          );
          document.documentElement.style.setProperty(
            `--modal-${modalId}-url-card-background`,
            modalSettings.urlCardBackground || '#93cbe5'
          );
          document.documentElement.style.setProperty(
            `--modal-${modalId}-url-card-border-color`,
            modalSettings.urlCardBorderColor || '#000000'
          );
          document.documentElement.style.setProperty(
            `--modal-${modalId}-url-title-color`,
            modalSettings.urlTitleColor || '#000000'
          );
          document.documentElement.style.setProperty(
            `--modal-${modalId}-url-text-color`,
            modalSettings.urlTextColor || '#f3ecec'
          );
          document.documentElement.style.setProperty(
            `--modal-${modalId}-url-meta-text-color`,
            modalSettings.urlMetaTextColor || 'rgba(252, 254, 255, 0.99)'
          );
          document.documentElement.style.setProperty(
            `--modal-${modalId}-app-card-background`,
            modalSettings.appCardBackground || 'rgba(225, 233, 225, 1)'
          );
          document.documentElement.style.setProperty(
            `--modal-${modalId}-app-card-border-color`,
            modalSettings.appCardBorderColor || '#000000'
          );
          document.documentElement.style.setProperty(
            `--modal-${modalId}-app-title-color`,
            modalSettings.appTitleColor || '#000000'
          );
          document.documentElement.style.setProperty(
            `--modal-${modalId}-app-text-color`,
            modalSettings.appTextColor || 'rgba(0, 0, 0, 0.7)'
          );
          document.documentElement.style.setProperty(
            `--modal-${modalId}-app-meta-text-color`,
            modalSettings.appMetaTextColor || '#070000'
          );
          document.documentElement.style.setProperty(
            `--modal-${modalId}-period-block-background`,
            modalSettings.periodBlockBackground || 'rgba(0, 0, 0, 0.05)'
          );
          document.documentElement.style.setProperty(
            `--modal-${modalId}-period-block-border-color`,
            modalSettings.periodBlockBorderColor || '#000000'
          );
          document.documentElement.style.setProperty(
            `--modal-${modalId}-period-title-color`,
            modalSettings.periodTitleColor || '#000000'
          );
          document.documentElement.style.setProperty(
            `--modal-${modalId}-period-text-color`,
            modalSettings.periodTextColor || 'rgba(134, 3, 3, 0.7)'
          );
          document.documentElement.style.setProperty(
            `--modal-${modalId}-screenshot-card-background`,
            modalSettings.screenshotCardBackground || 'rgba(255, 224, 130, 0.44)'
          );
          document.documentElement.style.setProperty(
            `--modal-${modalId}-screenshot-card-border-color`,
            modalSettings.screenshotCardBorderColor || 'rgba(0, 0, 0, 0.3)'
          );
          document.documentElement.style.setProperty(
            `--modal-${modalId}-screenshot-text-color`,
            modalSettings.screenshotTextColor || 'rgba(0, 0, 0, 0.5)'
          );
          document.documentElement.style.setProperty(
            `--modal-${modalId}-screenshot-download-button-background`,
            modalSettings.screenshotDownloadButtonBackground || 'rgb(13, 232, 86)'
          );
          document.documentElement.style.setProperty(
            `--modal-${modalId}-screenshot-download-button-text-color`,
            modalSettings.screenshotDownloadButtonTextColor || '#ffffff'
          );
          document.documentElement.style.setProperty(
            `--modal-${modalId}-screenshot-print-button-background`,
            modalSettings.screenshotPrintButtonBackground || 'rgb(0, 0, 0)'
          );
          document.documentElement.style.setProperty(
            `--modal-${modalId}-screenshot-print-button-text-color`,
            modalSettings.screenshotPrintButtonTextColor || '#ffe082'
          );
        }

        // Стили текста
        document.documentElement.style.setProperty(`--modal-${modalId}-text-color`, modalSettings.textColor);
        document.documentElement.style.setProperty(`--modal-${modalId}-text-size`, modalSettings.textSize);
        document.documentElement.style.setProperty(`--modal-${modalId}-text-align`, modalSettings.textAlign);
        document.documentElement.style.setProperty(`--modal-${modalId}-font-family`, modalSettings.fontFamily);
      }
    });
  }

  // Применяем стили сайдбара
  const useHeaderBgForButtons = activeSettings.sidebarUseHeaderBackgroundForButtons;
  const buttonBg = useHeaderBgForButtons
    ? (activeSettings.sidebarHeaderBackgroundImage
      ? `url(${activeSettings.sidebarHeaderBackgroundImage})`
      : activeSettings.sidebarHeaderBackground)
    : (activeSettings.sidebarButtonBackgroundImage
      ? `url(${activeSettings.sidebarButtonBackgroundImage})`
      : activeSettings.sidebarButtonBackground);
  document.documentElement.style.setProperty('--sidebar-button-background', buttonBg);
  const buttonOpacity = useHeaderBgForButtons && activeSettings.sidebarHeaderBackgroundImage
    ? (activeSettings.sidebarHeaderBackgroundImageOpacity || 1)
    : (activeSettings.sidebarButtonBackgroundImageOpacity || 0.1);
  document.documentElement.style.setProperty('--sidebar-button-background-opacity', buttonOpacity);
  document.documentElement.style.setProperty('--sidebar-text-color', activeSettings.sidebarTextColor);
  document.documentElement.style.setProperty('--sidebar-text-size', activeSettings.sidebarTextSize);
  document.documentElement.style.setProperty('--sidebar-text-align', activeSettings.sidebarTextAlign || 'left');
  document.documentElement.style.setProperty('--sidebar-font-family', activeSettings.sidebarFontFamily);
  const headerBgIsGradient = typeof activeSettings.sidebarHeaderBackground === 'string'
    && activeSettings.sidebarHeaderBackground.includes('gradient');
  const headerBg = activeSettings.sidebarHeaderBackground;
  const headerBgImage = activeSettings.sidebarHeaderBackgroundImage
    ? `url(${activeSettings.sidebarHeaderBackgroundImage})`
    : (headerBgIsGradient ? headerBg : 'none');
  document.documentElement.style.setProperty('--sidebar-header-background', headerBg);
  document.documentElement.style.setProperty('--sidebar-header-background-image', headerBgImage);
  document.documentElement.style.setProperty('--sidebar-header-background-opacity', activeSettings.sidebarHeaderBackgroundImageOpacity || 1);
  document.documentElement.style.setProperty('--sidebar-header-name-color', activeSettings.sidebarHeaderNameColor || '#6dd5ed');
  document.documentElement.style.setProperty('--sidebar-header-department-color', activeSettings.sidebarHeaderDepartmentColor || '#b2bec3');
  document.documentElement.style.setProperty('--sidebar-header-avatar-offset-x', `${activeSettings.sidebarHeaderAvatarOffsetX || 0}px`);
  document.documentElement.style.setProperty('--sidebar-header-avatar-offset-y', `${activeSettings.sidebarHeaderAvatarOffsetY || 0}px`);

  const pickingLightLockId = 'warehouse-picking-light-lock';
  let pickingLightLockEl = document.getElementById(pickingLightLockId);
  if (!pickingLightLockEl) {
    pickingLightLockEl = document.createElement('style');
    pickingLightLockEl.id = pickingLightLockId;
    document.head.appendChild(pickingLightLockEl);
  }
  pickingLightLockEl.textContent = `
    .wh-picking-shell[data-picking-modal] {
      background: linear-gradient(160deg, #f8fafc 0%, #f1f5f9 50%, #e8eef4 100%) !important;
      color: #1a1d21 !important;
    }
    .wh-picking-shell[data-picking-modal] .picking-content {
      background: transparent !important;
      color: inherit !important;
    }
    .wh-picking-shell[data-picking-modal] h1,
    .wh-picking-shell[data-picking-modal] h2,
    .wh-picking-shell[data-picking-modal] h3 {
      color: #0d7377 !important;
      -webkit-text-fill-color: #0d7377 !important;
    }
    .wh-picking-shell[data-picking-modal] .picking-header-counter,
    .wh-picking-shell[data-picking-modal] .picking-swipe-hint,
    .wh-picking-shell[data-picking-modal] .picking-loading {
      color: #5a6578 !important;
      -webkit-text-fill-color: #5a6578 !important;
    }
    .wh-picking-shell[data-picking-modal] .picking-table thead .picking-thead-merged {
      background: transparent !important;
      border: none !important;
    }
    .wh-picking-shell[data-picking-modal] .picking-thead-labels {
      background: rgba(13, 115, 119, 0.10) !important;
      color: #0a5c5f !important;
      -webkit-text-fill-color: #0a5c5f !important;
      border: 1px solid #0d0d0d !important;
    }
    .wh-picking-shell[data-picking-modal] .picking-row-td-merged {
      background: transparent !important;
      border: none !important;
    }
    .wh-picking-shell[data-picking-modal] .picking-row-card {
      border: 1px solid #0d0d0d !important;
    }
    .wh-picking-shell[data-picking-modal] .picking-table-row:not(.done) .picking-row-card {
      background: rgba(255, 255, 255, 0.96) !important;
    }
    .wh-picking-shell[data-picking-modal] .picking-table-row.done .picking-row-card {
      background: rgba(34, 197, 94, 0.14) !important;
    }
    .wh-picking-shell[data-picking-modal] .picking-title-text,
    .wh-picking-shell[data-picking-modal] .picking-qty-required {
      color: #1a1d21 !important;
      -webkit-text-fill-color: #1a1d21 !important;
    }
    .wh-picking-shell[data-picking-modal] .picking-items {
      background: rgba(255, 255, 255, 0.94) !important;
      border: 1px solid rgba(0, 0, 0, 0.08) !important;
    }
    .wh-picking-shell[data-picking-modal] .picking-table {
      background: transparent !important;
      --picking-card-border: #0d0d0d !important;
    }
    .wh-picking-shell[data-picking-modal] .picking-table tbody {
      background: transparent !important;
    }
    .wh-picking-shell[data-picking-modal] .picking-scan-msg.ok {
      background: rgba(39, 174, 96, 0.15) !important;
      color: #166534 !important;
      -webkit-text-fill-color: #166534 !important;
    }
    .wh-picking-shell[data-picking-modal] .picking-scan-msg.err {
      background: rgba(231, 76, 60, 0.12) !important;
      color: #b91c1c !important;
      -webkit-text-fill-color: #b91c1c !important;
    }
    .wh-picking-shell[data-picking-modal] .btn-remove-from-order-text {
      background: rgba(231, 76, 60, 0.1) !important;
      color: #b91c1c !important;
      border: 1px solid rgba(185, 28, 28, 0.35) !important;
    }
    .wh-picking-shell[data-picking-modal] .picking-qty-controls .qty-pick-btn {
      background: #0d7377 !important;
      color: #ffffff !important;
      -webkit-text-fill-color: #ffffff !important;
      border: 1px solid rgba(0, 0, 0, 0.3) !important;
      font-weight: 800 !important;
    }
    .wh-picking-shell[data-picking-modal] .picking-qty-controls .qty-pick-btn:hover {
      background: #0a5c5f !important;
      color: #ffffff !important;
      -webkit-text-fill-color: #ffffff !important;
    }
  `;
  document.head.appendChild(pickingLightLockEl);
  
  console.log('✅ applyFrontendSettings: CSS переменные применены:', {
    '--sidebar-button-background': buttonBg,
    '--sidebar-text-color': activeSettings.sidebarTextColor,
    '--sidebar-text-size': activeSettings.sidebarTextSize,
    '--sidebar-text-align': activeSettings.sidebarTextAlign || 'left',
    '--sidebar-font-family': activeSettings.sidebarFontFamily
  });
};

// Сохранение настроек в localStorage
export const saveFrontendSettings = (settings) => {
  try {
    localStorage.setItem('frontendSettings', JSON.stringify(settings));
    // Отправляем событие для синхронизации между вкладками
    window.dispatchEvent(new Event('storage'));
  } catch (error) {
    console.error('Ошибка сохранения настроек фронтенда:', error);
  }
};

let frontendSettingsLocalApplied = false;
let frontendSettingsServerFetched = false;
let frontendSettingsListenersRegistered = false;

// Инициализация при старте приложения
export const initializeFrontendSettings = async (options = {}) => {
  const { forceServerFetch = false } = options;
  console.log('🚀 Инициализация настроек фронтенда...');
  
  // Сначала применяем локальные настройки (если есть)
  if (!frontendSettingsLocalApplied) {
    const localSettings = loadFrontendSettings();
    if (localSettings) {
      console.log('📥 Применяем локальные настройки при старте');
      applyFrontendSettings(localSettings);
      frontendSettingsLocalApplied = true;
    }
  }
  
  // Затем пытаемся загрузить с сервера (глобальные настройки)
  try {
    const token = localStorage.getItem('token');
    if (!token) {
      console.warn('⚠️ Токен не найден, пропускаем загрузку настроек с сервера');
      return;
    }
    if (frontendSettingsServerFetched && !forceServerFetch) {
      return;
    }
    
    const response = await fetch('/api/frontend-settings', {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });
    
    if (response.ok) {
      const result = await response.json();
      if (result.success && result.settings) {
        console.log('📥 Глобальные настройки фронтенда загружены с сервера при запуске');
        normalizeSettingsVpr(result.settings);
        console.log('📦 Settings preview:', JSON.stringify(result.settings).substring(0, 200));
        localStorage.setItem('frontendSettings', JSON.stringify(result.settings));
        applyFrontendSettings(result.settings);
        window.dispatchEvent(new CustomEvent('frontendSettingsUpdated', { detail: { source: 'global', settings: result.settings } }));
        frontendSettingsServerFetched = true;
      } else {
        console.log('ℹ️ Глобальные настройки на сервере не найдены, используем локальные');
      }
    } else {
      console.warn('⚠️ Не удалось загрузить настройки с сервера (статус:', response.status, ')');
    }
  } catch (error) {
    console.warn('⚠️ Не удалось загрузить настройки фронтенда с сервера, используем локальные:', error);
  }

  if (!frontendSettingsListenersRegistered) {
    frontendSettingsListenersRegistered = true;
    // Слушаем изменения в localStorage (для синхронизации между вкладками)
    window.addEventListener('storage', (e) => {
      if (e.key === 'frontendSettings') {
        applyFrontendSettings();
      }
    });
    
    // Слушаем WebSocket для синхронизации с другими устройствами
    const registerWebSocketHandler = () => {
      if (window.socket && window.socket.connected) {
        console.log('📡 Регистрируем обработчик frontend-settings-updated');
        window.socket.on('frontend-settings-updated', (updatedSettings) => {
          if (updatedSettings === null) {
            // Сброс настроек к дефолтным
            console.log('📡 Получен сброс настроек через WebSocket (глобальная синхронизация)');
          localStorage.removeItem('frontendSettings');
          applyFrontendSettings(DEFAULT_SETTINGS);
          window.dispatchEvent(new CustomEvent('frontendSettingsUpdated', { detail: { source: 'global', settings: DEFAULT_SETTINGS } }));
            frontendSettingsServerFetched = false;
            // Перезагружаем страницу для полного сброса
            setTimeout(() => {
              window.location.reload();
            }, 500);
          } else {
            console.log('📡 Получены обновленные настройки фронтенда через WebSocket (глобальная синхронизация)');
            normalizeSettingsVpr(updatedSettings);
            console.log('📦 Updated settings preview:', JSON.stringify(updatedSettings).substring(0, 200));
          localStorage.setItem('frontendSettings', JSON.stringify(updatedSettings));
          applyFrontendSettings(updatedSettings);
          window.dispatchEvent(new CustomEvent('frontendSettingsUpdated', { detail: { source: 'global', settings: updatedSettings } }));
            frontendSettingsServerFetched = true;
          }
        });
      } else {
        // Если socket еще не готов, пробуем через небольшую задержку
        setTimeout(registerWebSocketHandler, 500);
      }
    };
    
    // Пробуем зарегистрировать сразу
    registerWebSocketHandler();
    
    // Также слушаем событие подключения socket
    window.addEventListener('socket-connected', () => {
      console.log('📡 Socket connected, регистрируем обработчик frontend-settings-updated');
      registerWebSocketHandler();
    });
  }
};

